import { Component } from '@angular/core';
import { TableWrapperOptions } from '../../../services/global/global-interfaces';
import { UtilService } from '../../../services/util.service';
import { PermissionService } from '../../../services/permission.service';

@Component({
  selector: 'sb-page-time-types',
  templateUrl: './time-types.component.html',
  styleUrls: ['./time-types.component.scss'],
  standalone: false,
})
export class TimeTypesComponent {
  loading: boolean;
  timeTypes: any; // TimeTypeDTO[];

  debounceTimer: ReturnType<typeof setTimeout>;

  options: TableWrapperOptions;

  constructor(
    public util: UtilService,
    public permissionService: PermissionService
  ) {
    this.timeTypes = [];
    this.debounceTimer = null;
    this.loading = true;
  }

  requestDebounced(options?: TableWrapperOptions) {
    if (options) {
      this.options = options;
    }
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }
    this.debounceTimer = setTimeout(() => {
      this.refreshFromServer();
    }, 500);
  }

  refreshFromServer() {
    /*
    this.api.shared_TimeType_getTimeTypes({
      search: this.util.encodeSearchQueryParam(this.options.exactMatch, this.options.search),
    }, this.options.pagination).subscribe((timeTypes: TimeTypeDTO[]) => {
      this.timeTypes = timeTypes;
      this.loading = false;
    }, error => {
      this.errorService.errorHandler(error);
    });
     */
  }

  /*
  delete(timeTypesID: number) {
    this.modalService.confirm({
      title: this.translate.instant('lang.globals.deleteColor'),
      message: this.translate.instant('lang.globals.deleteColorMessage'),
      yes: this.translate.instant('lang.globals.yes'),
      no: this.translate.instant('lang.globals.no')
    }).then((result: boolean) => {
      if (result) {
        this.api.shared_ColorDefinition_deleteColorDefinition(timeTypesID).subscribe(() => {
          this.refreshFromServer();
        }, error => {
          this.errorService.errorHandler(error);
        });
      }
    }).catch(() => {
    });
  }
*/
}
